import React, { useState } from "react";
import {
  FaChevronDown,
  FaChevronRight,
  FaCalendarAlt,
} from "react-icons/fa";
import { IoMdPerson } from "react-icons/io";
import Moment from "react-moment";
import { currencySymbolLeft } from "../../../../functions/Functions";
import { useCustomHooks } from "../../../../functions/Hooks";

const CustomerOrderList = ({ show, onHide, name, cusotmerOrder }) => {
  const { roundOffPrice } = useCustomHooks();
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (orderId) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(orderId)) {
      newExpanded.delete(orderId);
    } else {
      newExpanded.add(orderId);
    }
    setExpandedRows(newExpanded);
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      Delivered: "badge bg-primary",
      Processing: "badge bg-info",
      Cancelled: "badge bg-red",
    };
    const statusBadge = (status?.is_cancelled || status?.is_refund) ? "Cancelled" : (status?.is_paid ? "Delivered" : "Processing");
    return statusClasses[statusBadge] || "badge";
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade showing">
        <div className="modal-dialog modal-lg my-1">
          <div className="modal-content">
            <div className="modal-header xslg-text" style={{padding:"0.75rem 0.9rem"}}>
              <IoMdPerson style={{ marginRight: "8px" }} />
              {name}
              <button
                onClick={() => onHide()}
                type="button"
                className="btn-close"
              ></button>
            </div>
            <div
              className="modal-body pt-0 mt-2 bill_modal_scroll"
              style={{ maxHeight: "calc(100vh - 20rem)" }}
            >
              <table className="table table-hover table-responsive">
                <thead>
                  <tr
                    style={{
                      position: "sticky",
                      top: "0px",
                      backgroundColor: "white",
                    }}
                  >
                    <th style={{ width: "50px" }}></th>
                    <th>Order ID</th>
                    <th>
                      <FaCalendarAlt className="mr-1" />
                      Date
                    </th>
                    <th>Status</th>
                    <th className="text-end">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {cusotmerOrder?.length ? cusotmerOrder.map((order) => (
                    <React.Fragment key={order.id}>
                      <tr
                        className="cursor-pointer"
                        onClick={() => toggleRow(order.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="py-1 text-center">
                          <button
                            className="btn btn-small"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleRow(order.id);
                            }}
                          >
                            {expandedRows.has(order.id) ? (
                              <FaChevronDown />
                            ) : (
                              <FaChevronRight />
                            )}
                          </button>
                        </td>
                        <td className="py-1 fw-bold text-primary">{order.id}</td>
                        <td className="py-1"><Moment format="DD-MM-YYYY">{order.order_date}</Moment></td>
                        <td className="py-1">
                          <span className={getStatusBadge(order)}>
                            {parseInt(order?.is_cancelled) === 0 ? (
                            [
                              parseInt(order?.is_paid) === 1 &&
                              parseInt(order?.is_refund) === 0 ? (
                                <span>
                                  Paid
                                </span>
                                ) : parseInt(order?.is_refund) === 1 ? (
                                <span >
                                  Refund
                                </span>
                                ) : (
                                <span>
                                  processing
                                </span>
                              ),
                            ]
                            ) : (
                            <span>
                              Cancelled
                            </span>
                            )}
                          </span>
                        </td>
                        <td className="py-1 text-end fw-bold">
                          {currencySymbolLeft()}{roundOffPrice(order.total_payable)}
                        </td>
                      </tr>
                      {expandedRows.has(order.id) &&
                        order.order_item.map(
                          (item, index) => (
                            (
                              <>
                                <tr
                                  key={`${order.id}-item-${item.id}`}
                                  style={{ backgroundColor: "#fafafa", fontSize: "15px", transition: "all 0.2s ease"}}
                                  onClick={()=>toggleRow(item.id)}
                                >
                                  <td className="py-1">
                                    {item?.properties && JSON.parse(item.properties).length > 0 && (
                                      <button
                                        className="btn btn-mini"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          toggleRow(item.id)
                                        }}
                                        style={{ fontSize: "10px" }}
                                      >
                                        {expandedRows.has(item.id) ? <FaChevronDown /> : <FaChevronRight />}
                                      </button>
                                    )}
                                  </td>
                                  <td className="py-1" style={{ paddingLeft: "20px" }}>
                                    {index + 1}. {item.food_item}
                                    {item.variation && ` - ${item.variation}`}
                                  </td>
                                  <td className="py-1">
                                    Qty: {item.quantity}
                                  </td>
                                  <td className="py-1">
                                    <span className="badge bg-dark">Item</span>
                                  </td>
                                  <td className="py-1 text-end">
                                    {/* {currencySymbolLeft()}{roundOffPrice(item.price)} */}
                                  </td>
                                </tr>
                                {expandedRows.has(item.id) &&
                                  item.properties &&
                                  JSON.parse(item.properties).map((prpItem, prpIndex) => (
                                    <tr
                                      key={`${order.id}-item-${item.id}-prp-${prpIndex}`}
                                      style={{ backgroundColor: "#f5f5f5", fontSize: "14px", transition: "all 0.2s ease" }}
                                    >
                                      <td></td>
                                      <td style={{ paddingLeft: "30px" }}>
                                        {prpIndex + 1}. {prpItem.property}
                                      </td>
                                      <td>
                                        Qty: {prpItem.quantity}
                                      </td>
                                      <td>
                                        <span className="badge badge-inverse">
                                          Property
                                        </span>
                                      </td>
                                      <td>
                                      </td>
                                    </tr>
                                  ))}
                              </>
                            )
                          )
                        )}
                    </React.Fragment>
                  )) : ""}
                </tbody>
              </table>
            </div>

            <div className="modal-footer">
              <div className="float-left mr-2">
                <small className="text-muted">
                  Total Orders: {cusotmerOrder && cusotmerOrder.length} | Expanded: {expandedRows.size}
                </small>
              </div>
              <div>
                <button
                  className="btn rounded-sm hov-btn"
                  onClick={() => setExpandedRows(new Set())}
                >
                  Collapse All
                </button>
                <button
                  className="btn rounded-sm btn-primary"
                  onClick={() =>
                    setExpandedRows(new Set(cusotmerOrder?.length && cusotmerOrder.map((o) => o.id)))
                  }
                  style={{ marginLeft: "8px" }}
                >
                  Expand All
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerOrderList;
